<template>
  <div class="flex h-screen bg-gradient-to-r from-red-700 to-pink-600 justify-center items-center">
    <div class="block text-white pb-24">
      <h1 class="text-2xl ">Experimental sandbox for Web3 APIs</h1>
      <p>Please use this at your own risk.</p>
    </div>
  </div>
</template>
